<nz-upload [nzBeforeUpload]="beforeUpload" [nzAccept]="accept" class="upload">
    <ng-container *ngIf="render">
        <ng-container
            *ngTemplateOutlet="render"></ng-container>
    </ng-container>
    <button  *ngIf="!render" nz-button [id]="uploadElementId" class="upload-button text-btn-primary" [nzSize]="buttonSize" [disabled]="disabled"
            [nzLoading]="uploadLoading">
        {{ buttonText }}
    </button>
</nz-upload>
